module.exports = __webpack_public_path__ + "static/media/ekspozytory_02_C.5b6599f3.png";